export default __webpack_public_path__ + "static/media/wheel.b659a61c.png";